module.exports = __webpack_public_path__ + "media/illustrations/raf-share-77ac557f.svg";